// Controls whether we are in "hero mode" (main image + hotspots)
// vs "variant mode" (variant image, no hotspots)
let isHeroMode = true;

(function () {
  // Prevent double initialization (Shopify sections can re-run JS)
  if (window.__HOTSPOTS_INIT__) return;
  window.__HOTSPOTS_INIT__ = true;

  const DEBUG = true;

  // ----------------------------------
  // LOGGING HELPER
  // ----------------------------------
  function log(...args) {
    if (DEBUG) console.log("[HOTSPOTS]", ...args);
  }

  // ----------------------------------
  // HOTSPOT VISIBILITY
  // ----------------------------------

  // Hide all hotspots (used when variant is selected)
  function hideHotspots() {
    log("Hiding hotspots");

    document.querySelectorAll(".hotspot").forEach((h) => {
      h.classList.remove("is-active");
    });
  }

  // Show all hotspots (used in hero mode)
  function showHotspots() {
    log("Showing hotspots");

    document.querySelectorAll(".hotspot").forEach((h) => {
      h.classList.add("is-active");
    });
  }

  // ----------------------------------
  // HOTSPOT MODAL REBIND
  // ----------------------------------

  // After DOM/image changes, hotspot click events are lost.
  // This re-attaches click behavior so modals open correctly.
  function rebindHotspots() {
    document.querySelectorAll(".hotspot").forEach((h) => {
      h.addEventListener("click", (e) => {
        e.preventDefault();

        let modalId = h.getAttribute("data-open");

        if (!modalId) return;

        // Remove Shopify's ?slide= param (invalid for querySelector)
        if (modalId.includes("?")) {
          modalId = modalId.split("?")[0];
        }

        log("Opening modal:", modalId);

        // Use theme's own modal trigger system
        const trigger = document.querySelector(`[data-open="${modalId}"]`);

        if (trigger) {
          trigger.click();
        }
      });
    });
  }

  // ----------------------------------
  // FORCE HERO IMAGE
  // ----------------------------------

  // Overrides the main image to always show the FIRST gallery image
  // (used for hero mode + initial load)
  function forceFirstImageNow() {
    const firstThumbImg = document.querySelector(
      ".product-media--gallery-thumbnail img",
    );
    const mainContainer = document.querySelector('[id^="big-image"]');

    if (!firstThumbImg || !mainContainer) {
      log("Missing elements for image override");
      return;
    }

    const firstSrc = firstThumbImg.src;

    log("Forcing first image →", firstSrc);

    const img = mainContainer.querySelector("img");
    const picture = mainContainer.querySelector("picture");

    // Update main <img>
    if (img) {
      img.src = firstSrc;
      img.srcset = firstSrc;
    }

    // Update responsive <picture> sources
    if (picture) {
      picture.querySelectorAll("source").forEach((source) => {
        source.srcset = firstSrc;
      });
    }
  }

  // ----------------------------------
  // INITIAL LOAD
  // ----------------------------------

  document.addEventListener("DOMContentLoaded", () => {
    log("Initialized");

    setTimeout(() => {
      forceFirstImageNow();

      // 🔥 REQUIRED — show the image
      const main = document.querySelector('[id^="big-image"]');
      if (main) main.style.opacity = "1";

      showHotspots();
    }, 300);
  });

  // ----------------------------------
  // VARIANT IMAGE CONTROL
  // ----------------------------------

  // When Shopify tries to switch image due to variant:
  // If we are in hero mode → override it back to hero image
  document.addEventListener("variant:change", () => {
    if (isHeroMode) {
      log("Blocking variant image override");

      setTimeout(() => {
        forceFirstImageNow();
      }, 0);
    } else {
      // In variant mode → hide hotspots
      hideHotspots();
    }
  });

  // ----------------------------------
// SHOPIFY CUSTOMIZER SUPPORT
// ----------------------------------

// Re-run logic when section reloads in theme editor
document.addEventListener('shopify:section:load', () => {
    log('Section reloaded (Customizer)');

    setTimeout(() => {
      forceFirstImageNow();

      const main = document.querySelector('[id^="big-image"]');
      if (main) main.style.opacity = "1";

      showHotspots();
      rebindHotspots();
    }, 200);
  });

  // ----------------------------------
  // "VIEW FEATURES" BUTTON (EVENT DELEGATION)
  // ----------------------------------

  // Uses event delegation so it works on mobile + re-rendered DOM
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("#back-to-hotspots");

    if (!btn) return;

    log("Returning to hero");

    // Enable hero mode
    isHeroMode = true;

    // Force hero image
    forceFirstImageNow();

    // Show hotspots + rebind modal interactions
    setTimeout(() => {
      showHotspots();
      rebindHotspots();
    }, 200);
  });
})();
